import _get from 'lodash/get'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration, FlowValues } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsV1GetsafeDe } from '@flows/insurance/schemas'

const contents_insurance_owned = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath(
        'previous_insurance_in_last_5y'
        // Unwrap makes the schema required
      )]: BaseSchema_ContentsV1GetsafeDe.shape.previous_insurance_in_last_5y.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_insurance_owned.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      valueToStepName: {
        true: 'contents_damages',
        false: 'contents_deductibles',
      },
    },
    onSubmit: {
      type: 'simpleHook',

      callback: (flowValues: FlowValues) => {
        if (
          !_get(flowValues, params.helperFunctions.getParamPath('previous_insurance_in_last_5y'))
        ) {
          return {
            formValues: {
              [params.helperFunctions.getParamPath('number_of_claims_in_last_5y')]: '0',
            },
          }
        }
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_insurance_owned
